import { jsx as _jsx } from "preact/jsx-runtime";
import MiscForm from '@widgets/UpsellModal/components/MiscForm';
import { FormProvider, useForm, } from 'react-hook-form';
import { miscProductsSchema } from '@widgets/MiscProducts/validation/schema';
import { yupResolver } from '@hookform/resolvers/yup';
import { useContext } from 'react';
import { BasketUpsellComboFormCTX } from '@basket/types/BasketUpsellComboFormContext';
function MiscFormWrapper({ onComplete }) {
    const { item } = useContext(BasketUpsellComboFormCTX);
    const form = useForm({
        mode: 'onChange',
        resolver: yupResolver(miscProductsSchema),
        defaultValues: {
            MiscellaneousId: item.MiscellaneousId,
            PriceBands: item.PriceBands.map((band, idx) => ({
                PriceBandId: band.PriceBandId,
                Units: 0,
            })),
        },
    });
    return (_jsx(FormProvider, { ...form, children: _jsx(MiscForm, { postSubmit: (promises) => {
                if (promises) {
                    onComplete(promises);
                }
            }, options: BasketUpsellComboFormCTX, shouldSubmit: false }) }));
}
export default MiscFormWrapper;
